/**
 * Shift configurations
 */
export const SHIFTS = [
    { id: 1, key: "shift_one", label: "1st_shift" },
    { id: 2, key: "shift_two", label: "2nd_shift" },
    { id: 3, key: "shift_three", label: "3rd_shift" },
    { id: 4, key: "shift_four", label: "4th_shift" },
];

export const SHIFT_KEYS = {
    1: 'shift_one',
    2: 'shift_two',
    3: 'shift_three',
    4: 'shift_four'
};

export const getShiftKey = (shiftId) => {
    return SHIFTS.find((shift) => shift.id === shiftId)?.key;
};
